import {
    CREATE_FABRIC_INWARD_FAILURE_DK,
    CREATE_FABRIC_INWARD_REQUEST_DK,
    CREATE_FABRIC_INWARD_SUCCESS_DK,
    CREATE_USER_FORM_FABRIC_INWARD_DK,
    FETCH_SINGLE_FABRIC_INWARD_FAILURE_DK,
    FETCH_SINGLE_FABRIC_INWARD_REQUEST_DK,
    FETCH_SINGLE_FABRIC_INWARD_SUCCESS_DK,
    FETCH_FABRIC_INWARD_FAILURE_DK,
    FETCH_FABRIC_INWARD_REQUEST_DK,
    FETCH_FABRIC_INWARD_SUCCESS_DK,
    NAVIGATE_FABRIC_INWARD_DETAILS_DK,
    NAVIGATE_FABRIC_INWARD_DK,
    FABRIC_INWARD_USERFORM_RESET_DK,
    UPDATE_FABRIC_INWARD_FAILURE_DK,
    UPDATE_FABRIC_INWARD_REQUEST_DK,
    UPDATE_FABRIC_INWARD_SUCCESS_DK,
    DELETE_FABRIC_INWARD_REQUEST_DK,
    DELETE_FABRIC_INWARD_SUCCESS_DK,
    DELETE_FABRIC_INWARD_FAILURE_DK,
    FETCH_PENDING_FABRIC_PO_IN_INWARD_SUCCESS_DK,
    FETCH_PENDING_FABRIC_PO_IN_INWARD_REQUEST_DK,
    FETCH_PENDING_FABRIC_PO_IN_INWARD_FAILURE_DK,
    SET_ACTIVE_KEY_FABRIC_INWARD_DK,
    RESET_FORM_DATA_WITHOUT_FABRIC_INWARD_ID_DK,
    SET_PENDING_GRID_NAME_FABRIC_INWARD,
    SET_UNIT_NAME_FABRIC_INWARD_DK,
    FETCH_COMPLETE_FABRIC_PO_IN_INWARD_REQUEST_DK,
    FETCH_COMPLETE_FABRIC_PO_IN_INWARD_SUCCESS_DK,
    FETCH_COMPLETE_FABRIC_PO_IN_INWARD_FAILURE_DK,
    FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK,
    FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK,
    FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK
} from './fabricInward.actionsType';

export const FABRIC_INWARD_DK = 'fabricInwardDK';

let initialState = {
    loading: false,
    fabricInward: [],
    pendingFabricPO: [],
    completeFabricPO: [],
    reportSingleFabProgramInwardList: [],
    activeKey: 1,
    fabricInwardId: '',
    detailsId: [],
    fabricInwardForm: {
        fldSupplierInvoiceNo: null,
        fldSupplierInvoiceDate: null,
        fldSupplierInvoiceValue: null,
        fldSupplierDCNo: null,
        fldSupplierDCDate: null,
        fldDiscountValue: 0,
        fldIsInHouseDelivery: false,
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldSupplierDCValue: null,
        fldIsInHouseProduction: false,
        fldItemsTotalValue: 0,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldRoundoff: 0
    },
    selectedTeam: {},
    renderGridBtn: 'pendingGrid',
    unitId: '',
    isFabricInward: false,
    fabricInwardSelectedValue: null,
    errorMessage: '',
    iperrorMessage: ''
};

export let fabricInwardDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_FABRIC_INWARD_REQUEST_DK:
        case FETCH_PENDING_FABRIC_PO_IN_INWARD_REQUEST_DK:
        case CREATE_FABRIC_INWARD_REQUEST_DK:
        case FETCH_SINGLE_FABRIC_INWARD_REQUEST_DK:
        case UPDATE_FABRIC_INWARD_REQUEST_DK:
        case DELETE_FABRIC_INWARD_REQUEST_DK:
        case FETCH_COMPLETE_FABRIC_PO_IN_INWARD_REQUEST_DK:
        case FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_FABRIC_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                fabricInward: updatePayload
            };
        case FETCH_PENDING_FABRIC_PO_IN_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                pendingFabricPO: updatePayload
            };
        case FETCH_COMPLETE_FABRIC_PO_IN_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                completeFabricPO: updatePayload
            };
        case FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                reportSingleFabProgramInwardList: updatePayload?.Inward
            };
        case CREATE_FABRIC_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                fabricInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldDiscountValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                fabricInwardId: updatePayload[0]?.fldID,
                detailsId: updatePayload,
                activeKey: updatePayload[0]?.fldID && payload == true ? 2 : 1
            };
        case FETCH_SINGLE_FABRIC_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedTeam: updatePayload,
                fabricInwardForm: {
                    ...payload,
                    fldSupplierInvoiceDate: payload?.fldSupplierInvoiceDate && payload?.fldSupplierInvoiceDate.split('T')[0],
                    fldSupplierDCDate: payload?.fldSupplierDCDate && payload?.fldSupplierDCDate.split('T')[0]
                }
            };
        case UPDATE_FABRIC_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedTeam: {},
                fabricInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldDiscountValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                }
            };
        case DELETE_FABRIC_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                fabricInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldDiscountValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                }
            };
        case FETCH_FABRIC_INWARD_FAILURE_DK:
        case FETCH_PENDING_FABRIC_PO_IN_INWARD_FAILURE_DK:
        case FETCH_SINGLE_FABRIC_INWARD_FAILURE_DK:
        case CREATE_FABRIC_INWARD_FAILURE_DK:
        case UPDATE_FABRIC_INWARD_FAILURE_DK:
        case DELETE_FABRIC_INWARD_FAILURE_DK:
        case FETCH_COMPLETE_FABRIC_PO_IN_INWARD_FAILURE_DK:
        case FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_FABRIC_INWARD_DK:
            return {
                ...state,
                loading: false,
                fabricInwardForm: {
                    ...state.fabricInwardForm,
                    [payload.key]: payload.value
                }
            };
        case SET_ACTIVE_KEY_FABRIC_INWARD_DK:
            return {
                ...state,
                loading: false,
                activeKey: payload
            };
        case SET_PENDING_GRID_NAME_FABRIC_INWARD:
            return {
                ...state,
                renderGridBtn: payload
            };
        case SET_UNIT_NAME_FABRIC_INWARD_DK:
            return {
                ...state,
                unitId: payload
            };
        case FABRIC_INWARD_USERFORM_RESET_DK:
            return {
                ...state,
                fabricInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldDiscountValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                selectedTeam: {},
                fabricInwardId: '',
                detailsId: [],
                activeKey: 1
            };
        case RESET_FORM_DATA_WITHOUT_FABRIC_INWARD_ID_DK:
            return {
                ...state,
                fabricInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldDiscountValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldIsInHouseProduction: false,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldRoundoff: 0
                },
                selectedTeam: {}
            };
        case NAVIGATE_FABRIC_INWARD_DETAILS_DK:
            return {
                ...state,
                isFabricInward: true,
                fabricInwardSelectedValue: updatePayload.fabricInwardSelectedValue
            };
        case NAVIGATE_FABRIC_INWARD_DK:
            return {
                ...state,
                isFabricInward: false
            };
        default:
            return state;
    }
};
